<template>
  <div class="content">
    <header class="header">
      <p class="user-info">{{ $t('StoredNum') }}:{{ userName }}</p>
      <p class="recharge-instructions">
        {{ $t('StoredAmount') }}
        <span v-if="type == 1"
          >（1{{ $t('Point') }} = {{ $t('Currency') }}）</span
        >
      </p>
      <div class="info_message">
        <!-- <div v-if="type == 5">
          <van-field
            type="text"
            :label="$t('textlable1')"
            class="phone_number"
            :placeholder="$t('textlable1')"
            v-model.trim="full_name"
            :error-message="full_name_ts"
          />
        </div> -->
        <!-- <div style="margin-top: 1.25rem" v-if="type == 5">
          <van-field
            type="number"
            :label="$t('textlable2')"
            class="phone_number"
            :placeholder="$t('textlable2')"
            v-model.trim="phone"
            :error-message="phone_ts"
          />
        </div> -->
        <!-- <div style="margin-top: 1.25rem" v-if="type == 5">
          <van-field
            type="text"
            :label="$t('textlable3')"
            class="phone_number"
            :placeholder="$t('textlable3')"
            v-model.trim="email"
            :error-message="email_ts"
            @blur="isEmai"
          />
        </div> -->
        <!-- <div style="margin-top: 1.25rem" v-if="type == 5">
          <p style="padding-top: 0; color: #646566; font-size: 0.875rem">
            {{$t('textlable4')}}
          </p>
          <div class="select_box">
            <select
              class="select_list"
              v-model="paymentMethod"
              disabled="disabled"
            >
              <option
                :value="item.value"
                v-for="(item, index) in paymentMethodList"
                :key="index"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div> -->
        <!-- <div style="margin-top: 1.25rem" v-if="type == 5">
          <p style="padding-top: 0; color: #646566; font-size: 0.875rem">
            Bank code
          </p>
          <div class="select_box">
            <select class="select_list">
              <option value="">3345</option>
              <option value="">3345</option>
              <option value="">3345</option>
            </select>
          </div>
        </div> -->
      </div>
      <ul>
        <li
          class="order-list"
          v-for="(item, index) in orderList"
          :key="index"
          @click="createOrder(item.app_id, index, item.price)"
        >
          <a>
            <div class="detail">
              <div class="detail-left">
                <img
                  src="./order_img/coin2.png"
                  width="25"
                  height="25"
                  alt=""
                />
                <span>{{ item.qty }}{{ $t('Diamonds') }}</span>
              </div>
              <!-- <div class="detail-center">
                                <p class="rebate">$t('Rebate')</p>
                                <p class="rebate-text" style="margin-top:.1875rem">+750唱点</p>
                                <p class="rebate-text">+150唱豆</p>
                            </div> -->
              <div class="detail-right">
                <span v-if="type == 1">Mycard&nbsp;</span>
                {{ Number(item.price) / 1000 + 'K ' }}{{ item.unit }}
                <i class="iconfont icon-youjiantou" style="color: #ccc"></i>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </header>
  </div>
</template>

<script>
export default {
  name: 'order',
  data () {
    return {
      userInfo: '',
      userName: '',
      type: 1,
      uid: '',
      orderList: [],
      full_name: '',
      phone: '',
      email: '',
      paymentMethod: 'NL',
      email_ts: '',
      phone_ts: '',
      full_name_ts: '',
      paymentMethodList: [
        { name: 'NL', value: 'NL' },
        { name: 'VISA', value: 'VISA' },
        { name: 'ATM_ONLINE', value: 'ATM_ONLINE' },
        { name: 'ATM_OFFLINE', value: 'ATM_OFFLINE' },
        { name: 'NH_OFFLINE', value: 'NH_OFFLINE' },
        { name: 'IB_ONLINE', value: 'IB_ONLINE' },
        { name: 'CREDIT_CARD_PREPAID', value: 'CREDIT_CARD_PREPAID' },
        { name: 'QRCODE', value: 'QRCODE' },
        { name: 'CASH_IN_SHOP', value: 'CASH_IN_SHOP' },
        { name: 'BANK_TRANSFER_ONLINE', value: 'BANK_TRANSFER_ONLINE' },
        { name: 'QRCODE247', value: 'QRCODE247' }
      ],
    }
  },
  mounted () {
    this.orderList = this.$route.query.datalist
    this.userInfo = this.$route.query.userInfo
    this.type = this.$route.query.type
    this.userName = this.userInfo.data.nickname
    this.uid = this.userInfo.data.uid
    // console.log(this.type);
    //   console.log(this.$route.query.userInfo)
    // console.log(this.$route.query.datalist)
  },
  methods: {
    isEmai () {
      var reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!reg.test(this.email)) {
        this.email_ts = this.$t('textlable8')
      }
      if (reg.test(this.email)) {
        this.email_ts = ''
      }
    },
    createOrder (appId, index, price) {
      // console.log(appId,this.uid)
      if (this.type == 1) {
        this.$axios
          .get(
            `../api/api1.php?c=commodity._createMycardPay&app_id=${appId}&type=1&uid=${this.uid}`
          )
          .then(res => {

            if (res.data.code == 1) {
              alert(res.data.data.ReturnMsg)
            }

            if (res.data.code == 0) {
              const auth_code = res.data.data.auth_code
              window.location.href = `https://www.mycard520.com.tw/MyCardPay?AuthCode=${auth_code}`
            }
          })
      } else if (this.type == 2) {
        this.$axios
          .get(
            `../api/api1.php?c=commodity._createiPassPay&app_id=${appId}&type=1&uid=${this.uid}`
          )
          .then(res => {

            if (res.data.code == 1) {
              alert(res.data.data.ReturnMsg)
            }
            if (res.data.code == 0) {
              window.location.href = res.data.data.pay_url
            }
          })
      } else if (this.type == 5) {
        this.$router.push({
          path: '/nganluongData',
          query: { uid: this.uid,price:price,appId:appId },
        })
        // if (!this.full_name) {
        //   this.full_name_ts = this.$t('textlable5')
        //   alert(this.$t('textlable5'))
        //   return
        // }
        // if (!this.phone) {
        //   this.phone_ts = this.$t('textlable6')
        //   alert(this.$t('textlable6'))

        //   return
        // }
        // if (!this.email) {
        //   this.email_ts = this.$t('textlable7')
        //   alert(this.$t('textlable7'))

        //   return
        // }
        // if (this.email) {
        //   var reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        //   if (!reg.test(this.email)) {
        //     this.email_ts = this.$t('textlable8')
        //     alert(this.$t('textlable8'))

        //     return
        //   }
        // }
        // this.$axios
        //   .get(
        //     `../api/api1.php?c=commodity._createNganluongPay&app_id=${appId}&type=1&uid=${this.uid}&payment_method=${this.paymentMethod}&bank_code=&buyer_fullname=${this.full_name}&buyer_email=${this.email}&buyer_mobile=${this.phone}`
        //   )
        //   .then(res => {

        //     if (res.data.code == 1) {
        //       alert(res.data.data.ReturnMsg)
        //     }
        //     if (res.data.code == 0) {
        //       window.location.href = res.data.data.pay_url['0']
        //     }
        //   })
      } else if (this.type == 6) {
        this.$axios
          .get(
            `../api/api1.php?c=commodity._createUpayCashCardPay&app_id=${appId}&type=1&equipment_type=1&uid=${this.uid}`
          )
          .then(res => {
            if (res.data.code == 1) {
              alert(res.data.data.ReturnMsg)
            }
            if (res.data.code == 0) {
              window.location.href = res.data.data.pay_url
            }
          })
      } else {
        this.$axios
          .get(
            `../api/api1.php?c=commodity._createPayermaxPay&app_id=${appId}&type=1&uid=${this.uid}`
          )
          .then(res => {

            if (res.data.code == 1) {
              alert(res.data.data.ReturnMsg)
            }
            if (res.data.code == 0) {
              window.location.href = res.data.data.pay_url
            }
          })
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.content {
  width: 90%;
  height: 100vh;
  background: #fff;
  margin: 0 auto;

  .header {
    .user-info {
      width: 100%;
      line-height: 1.5;
      text-align: center;
    }

    .recharge-instructions {
      border-left: 0.3125rem solid #f64d5d;
      padding-left: 1.25rem;
      width: 100%;
      height: 2.625rem;
      line-height: 1.5;
      background-color: #ebebeb;
      color: #696969;
      font-size: 0.875rem;
    }

    ul {
      .order-list {
        width: 100%;
        height: 4.125rem;
        border-bottom: 0.0625rem solid #dee2e6;
        cursor: pointer;

        :hover {
          background: #FFFEC9;
        }

        .detail {
          // width:95%
          height: 4.125rem;
          margin: 0 auto;
          display: flex;
          align-items: center;
          position: relative;

          .detail-left {
            margin-left: 0.625rem;

            img {
              vertical-align: top;
            }

            span {
              font-size: 73%;
              color: #343a40;
              font-family: 'Microsoft JhengHei';
              margin-left: 0.3125rem;
              line-height: 1.3125rem;
            }
          }

          .detail-center {
            flex: 1;
            margin-left: 0.375rem;

            .rebate {
              width: 1.75rem;
              height: 0.8125rem;
              font-size: 0.5rem;
              color: #fff;
              line-height: 0.8125rem;
              text-align: center;
              background-color: #ff4040;
              border-radius: 0.25rem;
            }

            .rebate-text {
              color: #ff4040;
              font-size: 0.75rem;
              line-height: 0.9375rem;
            }
          }

          .detail-right {
            position: absolute;
            right: 0;
            color: #52c5a0;
            font-size: 0.75rem;
          }
        }
      }
    }

    .info_message {
      padding: 0.7rem 0.5rem 1rem;
    }

    .phone_number {
      >>>, .van-field {
        padding: 0;
        flex-direction: column;

        .van-field__label {
          width: auto;
        }

        .van-field__control {
          border: 1px solid #cbcbcb;
          padding-left: 0.625rem;
          height: 2.1875rem;
          border-radius: 0.3125rem;
        }
      }
    }

    .select_box {
      margin-top: 0.4rem;

      .select_list {
        width: 100%;
        border: 1px solid #cbcbcb;
        height: 2.1875rem;
        border-radius: 0.3125rem;
      }
    }
  }
}
</style>
